<template>
  <ServiceContentList
    v-bind="props"
    @page-change="emit('page-change', $event)"
    @item-click="emit('item-click', $event)"
  >
    <template #item="{ item, highlightText }">
      <h3 v-safe-html="highlightText(item.title)" class="service-content-list__item-title"></h3>
      <p
        v-if="shouldShowSummary(item)"
        v-safe-html="highlightText(getSummaryText(item))"
        class="service-content-list__item-summary"
      ></p>
      <div
        v-if="getUniqueProductModels(item).length > 0"
        class="service-content-list__item-products"
      >
        <span class="service-content-list__item-products-content">
          <span class="service-content-list__item-products-label">适用产品：</span>
          <span
            v-safe-html="highlightText(getDisplayProductModels(item).join('，'))"
            class="service-content-list__item-products-names"
          ></span>
        </span>
      </div>
      <span v-if="item.updateTime" class="service-content-list__item-update-time">{{
        item.updateTime
      }}</span>
    </template>
  </ServiceContentList>
</template>

<script setup>
/**
 * @description 帮助中心内容项，列表外壳统一复用 ServiceContentList。
 */
import ServiceContentList from '~/components/website/service/ServiceContentList.vue'
import { resolveApplicableProductModels } from '~/utils/website/helpProductModels'

const props = defineProps({
  contentList: { type: Array, default: () => [] },
  total: { type: Number, default: 0 },
  current: { type: Number, default: 1 },
  pageSize: { type: Number, default: 10 },
  loading: { type: Boolean, default: false },
  keyword: { type: String, default: '' },
})

const emit = defineEmits(['page-change', 'item-click'])
const getSummaryText = (item) => item?.abstract || item?.abstractText || ''

const stripHtmlToText = (raw) => {
  if (raw == null || raw === '') return ''
  return String(raw)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

const isPlaceholderText = (text) => {
  if (!text) return true
  if (/^[-–—_\s]+$/.test(text)) return true
  if (/^\d{1,8}$/.test(text)) return true
  return false
}

const shouldShowSummary = (item) => !isPlaceholderText(stripHtmlToText(getSummaryText(item)))

const getUniqueProductModels = (item) =>
  resolveApplicableProductModels(item).filter((name) => {
    if (name == null || name === '') return false
    const normalizedName = String(name).trim()
    return normalizedName && !isPlaceholderText(normalizedName)
  })

const getDisplayProductModels = (item) => {
  const names = getUniqueProductModels(item)
  const keyword = props.keyword.trim().toLowerCase()

  if (!keyword) return names

  return [...names].sort((a, b) => {
    const aMatched = String(a).toLowerCase().includes(keyword)
    const bMatched = String(b).toLowerCase().includes(keyword)
    if (aMatched === bMatched) return 0
    return aMatched ? -1 : 1
  })
}
</script>
